import maulLogo from "../../images/maul-green-text-logo.svg?url"
import { holidaysByFsp } from "./holidays"
import { timeRules } from "./time-rules/maul/time-rules"
import maulFavSvg from "/maul-fav/maul_favicon.svg?url"
import maulFavIco32 from "/maul-fav/maul_favicon_32x32.ico"
import maulFavAppleTouch from "/maul-fav/maul_favicon_apple_180x180.png"
import { getClientEnv } from "./client-env-init"

export const maulFAQs = {
  general: {
    id: "general",
    header: "faq.general",
    svg: "test",
    content: [
      {
        question: "faq.general1",
        answer: "faq.generalanswer1",
      },
      {
        question: "faq.general2",
        answer: "faq.generalanswer2",
      },
      {
        question: "faq.general3",
        answer: "faq.generalanswer3",
      },
      {
        question: "faq.general4",
        answer: "faq.generalanswer4",
      },
      {
        question: "faq.general5",
        answer: "faq.generalanswer5",
      },
      {
        question: "faq.general6",
        answer: "faq.generalanswer6",
      },
      {
        question: "faq.general7",
        answer: "faq.generalanswer7",
      },
      // {
      //   question: "faq.general8",
      //   answer: "faq.generalanswer8",
      // },
      // {
      //   question: "faq.general9",
      //   answer: "faq.generalanswer9",
      // },
      // {
      //   question: "faq.general10",
      //   answer: "faq.generalanswer10",
      // },
    ],
  },
}

export const maulConfig = {
  fspId: "maul",
  fspName: "Maul",
  timeZone: "Atlantic/Reykjavik",
  url: "https://maul.is",
  ns: "maul",
  faqs: maulFAQs,
  namespace: "maul",
  colorTheme: "maul",
  // The Radix color that has been overwritten by the Maul primary green color
  pColor: "jade",
  cognito: {
    userPoolId: getClientEnv().VITE_AWS_MAUL_USER_POOL_ID,
    userPoolWebClientId: getClientEnv().VITE_AWS_MAUL_USER_POOL_WEB_CLIENT_ID,
  },
  fathomAnalytics: {
    siteId: "CJCYDVNN",
    includedDomains: ["www.restaurant.maul.is", "restaurant.maul.is"],
  },
  font: "Rubik",
  headingFont: "RocGrotesk",
  logo: {
    src: maulLogo,
    alt: "Maul logo",
  },
  // https://evilmartians.com/chronicles/how-to-favicon-in-2021-six-files-that-fit-most-needs
  // we need to take a look at this link. This is the correct way we should do this, by having different favicons
  // for different devices.
  favIcons: {
    ico32: maulFavIco32,
    svg: maulFavSvg,
    appleTouch: maulFavAppleTouch,
  },
  languages: [
    { code: "is", label: "Íslenska" },
    { code: "en-GB", label: "English" },
  ],
  socials: {
    instagram: "https://www.instagram.com/maul.reykjavik/",
    facebook: "https://www.facebook.com/maulreykjavik/",
    // At the time of writing, June 17th 2025, our last X post was in 2022. So let's disable it for now.
    // x: "https://x.com/maulreykjavik",
    x: null,
    linkedin: null,
    blog: "https://www.maul.is/blog",
  },
  supportPhone: "519 2939",
  supportEmail: "maul@maul.is",
  // The "Maul spjall" Front Chat channel. Public by design: it ships in the page either way.
  frontChatId: "9b788e45e6aafa8e688a0d65a19d00f6",
  appRevalidationIntervalMs: 5 * 60 * 1000,
  enablePeriodicRevalidation: true,
  enableRevalidateOnFocus: true,
  enableSecondaryMarket: true,
  showAllergens: true,
  pickupTimesByMealTime: {
    Lunch: {
      weekdays: "10:40",
      weekend: "11:30",
    },
    Dinner: {
      weekdays: "17:45",
      weekend: "18:30",
    },
  },
  timeRules,
  holidaysMap: holidaysByFsp.maulYearlyHolidays,
} as const
